module.exports = __webpack_public_path__ + "img/pick5.c50d33a3.png";